import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from 'app/public/services/subscription.service';
import { Language, SiteDocsUrl } from 'app/shared/model/enums';


@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss',
  changeDetection:ChangeDetectionStrategy.OnPush
  
})
export class TermsOfUseComponent implements OnInit {
  pdfSrc:string
  language:Language
  docType:SiteDocsUrl;
  
  constructor(private route: ActivatedRoute,private _service:SubscriptionService,private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
       this.language = params['language'] || null;
    });
   if(this.language==Language.he)
     this.docType=SiteDocsUrl.TermsOfUseHebrew
    else 
    this.docType=SiteDocsUrl.TermsOfUseEnglish
  
    this._service.getSiteDocUrl(this.docType).subscribe(
      succ=>{
        this.pdfSrc=succ
        this.cdr.markForCheck()
      }
    )
  }

}

